import React from 'react';

import { useAIContext } from '@atlassian/ai-smart-button-api';

import { Greeting } from './greeting';
import { Reference } from './reference';

export function HeadingSection({ name }: { name: string }): React.JSX.Element {
	const context = useAIContext();

	return context ? <Reference /> : <Greeting name={name} />;
}
